module.exports = __webpack_public_path__ + "static/media/Sort.43113af9.svg";